export default {
  /*
   * create() crea una instancia de contacto con la aplicación
   */
  create(data) {
    return Vue.http.post('contact', {data}).then(response => response.data.data)
  }
}
